import React, { FC } from 'react';
import { Box, Stack, SvgIcon, Typography } from '@mui/material';
import styles from './ScanComponent.module.scss';
import ScanIcon from '../../assets/scan.svg';

interface ScanComponentProps {
    frontProfileImageUrl: string | null;
    sideProfileImageUrl: string | null;
}

const ScanComponent: FC<ScanComponentProps> = (props) => {
    const { frontProfileImageUrl, sideProfileImageUrl } = props;
    return (
        <div className={styles.ScanComponent} data-testid="ScanComponent">
            <Stack direction="row" alignItems="center">
                <SvgIcon sx={{ height: 24, width: 24 }}><ScanIcon /></SvgIcon>
                <Typography
                    sx={{ ml: 1.25, fontFamily: 'Poppins', fontWeight: '600', fontSize: '24px', lineHeight: '36px' }}
                >
                    Your scan
                </Typography>
            </Stack>
            <Box sx={{ bgcolor: '#000000', p: 4, height: '348px', mt: 1.75 }}>
                <Stack
                    direction="row"
                    justifyContent="space-evenly"
                    alignItems="center"
                    spacing={2}
                >
                    {frontProfileImageUrl
                        && (
                            <img
                                src={frontProfileImageUrl}
                                alt="front scan"
                                loading="lazy"
                                height="348px"
                            />
                        )}
                    {sideProfileImageUrl
                        && (
                            <img
                                src={sideProfileImageUrl}
                                alt="front scan"
                                loading="lazy"
                                height="348px"
                            />
                        )}
                </Stack>
            </Box>
        </div>
    );
};

export default ScanComponent;
